
import React, { useState, useEffect } from 'react';
import { ensureNewGenomeProCookie } from './WebserverUser';
import logo from '../../44444.png';
import './newgenome.css';

// Import modules
import Home from './modules/Home/Home.js';
import DataAccess from './modules/DataAccess/DataAccess.js';
import Documentation from './modules/Documentation/Documentation.js';
import Settings from './modules/Settings/Settings.js';

function NewGenome() {
  const [cookieId, setCookieId] = useState('');
  const [daysLeft, setDaysLeft] = useState(0);
  const [activeTab, setActiveTab] = useState('home');
  const [theme, setTheme] = useState('dark'); // 'dark' or 'light'

  useEffect(() => {
    const cookie = ensureNewGenomeProCookie();
    if (cookie) {
      setCookieId(cookie.id);
      const diff = cookie.expiry - Date.now();
      const days = Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));
      setDaysLeft(days);
    }
  }, []);

  const toggleTheme = () => {
    setTheme(currentTheme => (currentTheme === 'dark' ? 'light' : 'dark'));
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'home':
        return <Home />;
      case 'data-access':
        return <DataAccess />;
      case 'documentation':
        return <Documentation />;
      case 'settings':
        return <Settings toggleTheme={toggleTheme} theme={theme} />;
      default:
        return <Home />;
    }
  };

  const themeClass = theme === 'light' ? 'light-theme' : '';

  return (
    <div className={`WSNG-app-container ${themeClass}`}>
      <header className="WSNG-header">
        <div className="WSNG-header-left">
          <div className="WSNG-logo-container">
            <img src={logo} alt="NewGenome Logo" className="WSNG-logo" />
          </div>
          <nav className="WSNG-nav-tabs">
            <button
              className={`WSNG-nav-tab ${activeTab === 'home' ? 'active' : ''}`}
              onClick={() => setActiveTab('home')}
            >
              Home
            </button>
            <button
              className={`WSNG-nav-tab ${activeTab === 'data-access' ? 'active' : ''}`}
              onClick={() => setActiveTab('data-access')}
            >
              Data Access
            </button>
            <button
              className={`WSNG-nav-tab ${activeTab === 'documentation' ? 'active' : ''}`}
              onClick={() => setActiveTab('documentation')}
            >
              Documentation
            </button>
            <button
              className={`WSNG-nav-tab ${activeTab === 'settings' ? 'active' : ''}`}
              onClick={() => setActiveTab('settings')}
            >
              Settings
            </button>
          </nav>
        </div>
      </header>

      <main className="WSNG-content-area">
        {renderContent()}
      </main>

      <footer className="WSNG-footer">
        <div className="WSNG-cookie-icon">
          <i className="fas fa-cookie-bite"></i>
          <span className="WSNG-tooltip">{`ID: ${cookieId}\n${daysLeft} days left`}</span>
        </div>
      </footer>
    </div>
  );
}

export default NewGenome;